const body = document.body;
let cookieAge = getCookie("adultchildren");
let cookieFreeGift = getCookie("bobochoses_freegift");

// Multicolumn
const header = document.querySelector(".header__inline-menu");
const multicolumnCookieAge = document.getElementById("multicolumnCookieAge");
const path = window.location.pathname;
const getVars = window.location.search;
const adultSwitcher = document.getElementById("adultSwitcher");
const childrenSwitcher = document.getElementById("childrenSwitcher");
const adultSwitcherDrawer = document.getElementById("adultSwitcherDrawer");
const childrenSwitcherDrawer = document.getElementById("childrenSwitcherDrawer");
const isBlogPage = path.includes("/blogs/");


let lang = "";
if (path.split('/')[1].includes("-")) {
  lang = "/" + path.split('/')[1];
} else if (path.split('/')[1] == "es") {
  lang = "/es";
}
const homePath = lang != "" ? lang : "/";
const homeGetVars = getVars != "" ? getVars : "";

toggleModalAgeVisibility();

if (body.classList.contains("type-collection") || body.classList.contains("type-product")) {
  if (cookieAge != "adult" && body.classList.contains("adult")) {
    setCookie("adult");
  } else if (cookieAge != "children" && body.classList.contains("children")) {
    setCookie("children");
  } else if (cookieAge == "" ) {
    setCookie("children");
  }
} else if (cookieAge == "" && (!multicolumnCookieAge || isBlogPage )) {
  setCookie("children");
  if(isBlogPage) {
    toggleModalAgeVisibility();
  }
}

cookieAge == "adult" ? body.dataset.age = "adult" : body.dataset.age = "children";

if (multicolumnCookieAge) {
  const adultButton = document.getElementById("adultButton");
  const childrenButton = document.getElementById("childrenButton");
  adultButton.addEventListener("click", function() {
    setCookie("adult");
    body.dataset.age = "adult";
  });
  
  childrenButton.addEventListener("click", function() {
    setCookie("children");
    body.dataset.age = "children";
  });
}

// Header
if (adultSwitcher) {
  adultSwitcher.addEventListener("click", function(e) {
    switchToAge(e, "adult");
  });
}

if (adultSwitcherDrawer) {
  adultSwitcherDrawer.addEventListener("click", function(e) {
    switchToAge(e, "adult");
  });
}

if(childrenSwitcher) {
  childrenSwitcher.addEventListener("click", function(e) {
    switchToAge(e, "children");
  });
}

if(childrenSwitcherDrawer) {
  childrenSwitcherDrawer.addEventListener("click", function(e) {
    switchToAge(e, "children");
  });
}

let homePathWithSlash = homePath + "/";

if ((path == homePath || path == homePathWithSlash) && cookieAge != '') {
  window.location.href = `${lang}/pages/${cookieAge}${homeGetVars}`;
  if(header) header.style.visibility = "visible";
} else if (path == `${lang}/pages/children${homeGetVars}`) {
  setCookie("children");
  body.dataset.age = "children";
  if(header) header.style.visibility = "visible";
} else if (path == `${lang}/pages/adult${homeGetVars}`) {
  setCookie("adult");
  body.dataset.age = "adult";
  if(header) header.style.visibility = "visible";
}

updateHomeLinks();

function setCookie(value) {
  let cookieString = `adultchildren=${value}; path=/`;
  document.cookie = cookieString;
  cookieAge = getCookie("adultchildren");
  if(header) header.style.visibility = "visible";
  updateHomeLinks();
}

function setCookieFreeGiftTheme(value) {
  let cookieString = `bobochoses_freegift=${value}; path=/`;
  document.cookie = cookieString;
  cookieFreeGift = getCookie("bobochoses_freegift");
}

function getCookie(nombre_cookie) {
  let nombre = nombre_cookie + "=";
  let cookies = document.cookie.split(';');
  for(let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    while (cookie.charAt(0) == ' ') {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(nombre) == 0) {
      return cookie.substring(nombre.length, cookie.length);
    }
  }
  return "";
}

function switchToAge(e, value) {
  e.preventDefault();
  setCookie(value);
  window.location.replace(`${lang}/pages/${value}`);
}

// Links Home
function updateHomeLinks() {
  const links = document.querySelectorAll(`a[href="${homePath}"]`);
  links.forEach(function(link) {
    if (cookieAge != '') link.setAttribute("href", `${lang}/pages/${cookieAge}`);
  });

  const linksBreadcrumbCheckout = document.querySelectorAll('.breadcrumbs a:not(a[href="'+homePath+'"])');
  linksBreadcrumbCheckout.forEach(function(link) {
    if (cookieAge != '') link.setAttribute("href", `${lang}/pages/${cookieAge}`);
  });  
}

function toggleModalAgeVisibility() {
  if (cookieAge != "") {
    if(header) header.style.visibility = "visible";
    if(multicolumnCookieAge) {
      multicolumnCookieAge.parentNode.style.display = "none";
    }
  }
}